import React from "react";
import { AuthGuard } from "./AuthGuard";

interface DevAuthGuardProps {
  children: React.ReactNode;
}

export const DevAuthGuard: React.FC<DevAuthGuardProps> = ({ children }) => {
  // In development mode with mock auth enabled, bypass authentication
  if (import.meta.env.VITE_USE_MOCK_AUTH === "true") {
    return <>{children}</>;
  }

  // In production or when mock auth is disabled, use real auth
  return <AuthGuard>{children}</AuthGuard>;
};

export default DevAuthGuard;
